import * as reactiveUtils from "@arcgis/core/core/reactiveUtils.js";
import Sketch from "@arcgis/core/widgets/Sketch";
import globalLayers from "../../../Utils/CustomerMaps/Maps/GlobaLMap";
import { lazyLoadArcGisMapModules } from "../../../Utils/CustomerMaps/Maps/LazyloadMap";
import Basemap from "@arcgis/core/Basemap";

function formatScale(scale: number): string {
    if (scale >= 1000) {
      const km = (scale / 1000)
      const meters = (scale % 1000)
      return `${Math.round(km)} km ${Math.round(meters)} m`;
    } else {
      const feet = Math.round(scale * 3.28084);
      return `${Math.round(scale)} m ${Math.round(feet)} ft`;
    }
  }

export async function watchLocationMarkerChanges() {
    const { reactiveUtils } = await lazyLoadArcGisMapModules()
    // will only be triggered when globalLayers.graphicLayerLocation?.visible is true 
    reactiveUtils.when(
        () => [globalLayers.view?.scale, globalLayers.view?.center, globalLayers.view?.zoom, globalLayers.map?.basemap], // to look for what evevtn,
        ([scale, center, zoom, basemap]: [scale: number, center: __esri.Point, zoom: number, basemap: Basemap]) => {
          const active1 = globalLayers.activeView;
            

            let zoomLevel = zoom?.toFixed(0);
            let scaleInFeet = formatScale(scale);
            // let scaleEle = document.querySelector('#scale') as HTMLSpanElement;
            let ele = document.querySelector('#zoomDiv') as HTMLSpanElement;
            if(ele && scale){
                // (document.querySelector('#zoomDiv') as HTMLSpanElement).innerText = zoomLevel;
                // (document.querySelector('#scale') as HTMLSpanElement).innerText = scaleInFeet
            }
        }
    );
    
}


export async function watchDrawToolChanges(sketchVM: Sketch) {
  
  // will only be triggered when globalLayers.graphicLayerLocation?.visible is true 
  reactiveUtils.watch(
      () => [sketchVM.activeTool], // to look for what evevtn,
      (tool : any) => {
          console.log(tool, 'activetool')
      }
  );
  
}
